module.exports = __webpack_public_path__ + "img/setaEsquerda.7fb1747b.svg";